import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"dense":"","outlined":"","clearable":"","hide-details":"auto","items":_vm.ehr_section_items,"label":_vm.label,"readonly":_vm.readonly},model:{value:(_vm.local_value),callback:function ($$v) {_vm.local_value=$$v},expression:"local_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }